import React from 'react';

interface FeatureCardProps {
  gifSrc: string;
  title: string;
  description: string;
  isSmaller?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ 
  gifSrc, 
  title, 
  description, 
  isSmaller = false 
}) => (
  <div className={`
    flex items-center gap-4 ${isSmaller ? 'py-4 px-6' : 'p-6'} rounded-lg border border-gray-700 hover:border-blue-400 
    transition w-full h-full relative overflow-hidden 
    bg-gradient-to-br from-gray-800/70 to-gray-900/70 backdrop-blur-sm
  `}>
    <div className={`${isSmaller ? 'w-10 h-10' : 'w-10 h-10'} flex-shrink-0 overflow-hidden rounded-md`}>
      <img 
        src={gifSrc} 
        alt={title}
        className="w-full h-full object-cover"
      />
    </div>
    <div className="flex-1">
      <h3 className={`${isSmaller ? 'text-lg' : 'text-lg'} font-semibold text-blue-400`}>{title}</h3>
      <p className={`${isSmaller ? 'text-sm' : 'text-sm'} text-gray-400`}>{description}</p>
    </div>
  </div>
);

export default FeatureCard; 